import { BotVariables } from '@feedyou/schema'
import { useSelector } from 'react-redux'

import { botVariablesSelector } from '../selectors/botVariablesSelector'

export function useBotVariables(): BotVariables {
  return useSelector(botVariablesSelector)
}
